<template>
    <div class="page">
        <Navigation pageName="policies" />
        <!--FILTRI E RICERCA-->
        <form class="filter-section" @submit.prevent="getPolicies(true)">
            <div class="filter-left">
                <label class="text-bold">{{ $t("Search") }}</label>
                <input class="input pl-2 select  text-small" v-model="filters.strToSearch" type="text" :placeholder="$t('Search')" />
            </div>
            <div class="filter-left">
                <label class="text-bold">{{ $t("Type") }}</label>
                <select class="pl-2 select  text-small" v-model="filters.type">
                    <option value="">{{ $t("Show all") }}</option>
                    <option v-for="type in $session.getPolicyTypes()" :value="type.id" :key="type.id">{{ $t(type.name) }}
                    </option>
                </select>
            </div>
            <div class="filter-left d-flex flex-align-end">
                <button @click="getPolicies(true)" class="button secondary">
                {{ $t('Filter') }}
                </button>
            </div>
        </form>
        
        <!--RISULTATI-->
        <div class="results-section">
            <div v-if="policies == null" class="d-flex flex-justify-center  p-5">
                <span class="mif-spinner2 fg-primary ani-spin mif-5x " />
            </div>
            <NoDataAvailable v-else-if="policies.length == 0" :message="$t('No policy has been created yet. Click Add Policy to create a new one.')" />
            <table v-else class="table border striped m-0 bg-white">
                <thead>
                    <tr>
                        <th>{{ $t("Name") }}</th>
                        <th>{{ $t("Type") }}</th>
                        <th class="text-center no-wrap">{{ $t("Created at") }}</th>
                        <th class="text-center no-wrap">{{ $t("Last Update") }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="policy in policies" class="mx-8 p-4  rounded m-6" v-bind:key="policy.id">
                        <td>
                            <a class="text-bold text-left m-0 button flat-button" :href="'#' + policy.id">
                            {{ policy.name }}
                            </a>
                        </td>
                        <td>
                            <label class="badge inline tertiary">{{ policy.name_type }}</label>
                        </td>
                        <td>
                            {{ policy.dt_creation.toLocalDate() }}
                        </td>
                        <td>
                            {{ policy.dt_last_edit.toLocalDate() }}
                        </td>
                        <!--    <td class="no-wrap">
                            <span class="mif-2x mif-email mr-4" :class="{ 'fg-gray': policy.enabled_email==false }"></span> 
                            <span class="mif-2x mif-mobile" :class="{ 'fg-gray': policy.enabled_push==false }"></span>
                            </td> -->
                        <td>
                            <ul class="listview flex-justify-end d-flex">
                                <router-link :to="'#' + policy.id" class="fg-dark">
                                    <li class="button flat-button">
                                        <span class="mif-2x mif-pencil"></span>
                                    </li>
                                </router-link>
                                <router-link :to="'#' + policy.id + '/delete'" class="fg-dark">
                                    <li class="button flat-button "> 
                                        <span class="mif-2x mif-bin"></span>
                                    </li>
                                </router-link>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>

import Navigation from './utils/Navigation.vue';
import NoDataAvailable from "./utils/NoDataAvailable.vue";
export default {
    name: "Policies",
    components: {
        Navigation,
        NoDataAvailable,
    },
    watch: {
        '$route': {
            handler: function(to, from) {
                if (to.hash&&to.hash.endsWith("/delete")) {
                    var polID=to.hash.split("/")[0].replace("#", "");
                    var policy=this.policies.find(p => p.id==polID);
                    if (policy!=null) this.deletePolicy(policy);
                    return;
                }
                if (to.hash) {
                    var polID=to.hash.replace("#", "");
                    this.openDialogPolicy(polID)
                }
            },
            deep: false,
            immediate: true
        }
    },
    data() {
        return {
            policies: null,
            filteredpolicies: null,
            filters: {
                strToSearch: "",
                type: ""
            }
        }
    },
    mounted: async function() {
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        let self=this;
        self.getPolicies(false);

        this.$root.$on('deletePolicy', policy => self.deletePolicy(policy));
        this.$root.$on("refreshPolicies", () => self.getPolicies(false));
    },
    unmounted: function() {
        this.$root.$off('deletePolicy');
        this.$root.$off("refreshPolicies");
    },


    methods: {
        getPolicies(applyFilters) {

            if (applyFilters) {
                this.policies.update(this.$session.getPolicies().filter(p =>
                    (this.filters.strToSearch==''||p.name.contains(this.filters.strToSearch))&&
                    ['', p.id_type].includes(this.filters.type)
                ));
                return;
            }

            this.$api.getPolicies().then(async policies => {
                this.policies = null;
                /* if (this.policies==null) {
                    //this.policies=[]
                } else {
                    this.policies.clear();
                    //await waitSeconds(0.1);
                } */
                //this.policies.update(policies);
                this.policies = policies;
                this.$session.setPolicies(this.policies);
            });
        },

        logNavigation(event) {
            console.log('Navigating to:', { name: 'Policies', params: { idPolicy: this.policy.id } });
        },

        async openDialogPolicy(id_policy) {
            var policy=await this.$api.getPolicy(id_policy);
            this.$root.$emit("OPENPOLICYVIEWDIALOG", policy, this.$session.getPCList());
        },

        /*  filteredList(data) {
             this.filteredpolicies = this.policies;
             this.filteredpolicies = this.policies.filter((group) => {
                 return group.name_group.toLowerCase().includes(data.toLowerCase())
             });
         }, */

        async deletePolicy(policy) {
            //Personalizzo la dialog da mostrare
            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            var dialogTitle=this.$t("Delete Policy");
            var dialogContent=this.$t('deleteConfirmation', { 0: policy.name });

            let self=this;
            this.$root.$on(dialogID, async ok => {
                var closeDialog=true;
                try {
                    if (!ok) {
                        return;
                    }

                    ok=await self.$api.deletePolicy(policy.id);

                    if (!ok) {
                        closeDialog=false;
                        return;
                    }

                    self.$session.deletePolicy(policy.id);
                    this.$root.$emit('CLOSEPOLICYVIEWDIALOG');
                    self.getPolicies(false);

                } finally {
                    if (closeDialog) {
                        self.$root.$off(dialogID);
                        self.$router.removeHash(); // prototype implementato in main.js
                    }
                }
            });

            //Avvio la richiesta che mi risponderà con un $emit
            this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent)
        }


    }
}
</script>
